import Vue from 'vue';
import Router from 'vue-router';
import Showreel from '@/views/Showreel.vue';
import Archive from '@/views/Archive.vue';
import About from '@/views/About.vue';
import Private from '@/views/Private.vue';
import Video from '@/views/Video.vue';
import PageNotFound from '@/views/PageNotFound.vue';
import InternalServerError from '@/views/InternalServerError.vue';
import store from '@/store';
import Axios from 'axios';


Vue.use(Router);


Axios.defaults.headers = { 'X-Requested-With': 'XMLHttpRequest' };


const getURL = (route) => {
  const privateGroupSegment = route.name && route.name.includes('private') ? `/${route.params.group}` : '';
  return `https://cms.bobpendar-hughes.com/data${privateGroupSegment}.json`;
};

const loadData = (route, next) => {
  if (store.state.hasLoaded) {
    next();
  } else {
    Axios
      .get(getURL(route))
      .then((response) => {
        store.commit('setData', response.data);
        next();
      })
      .catch((error) => {
        console.log(error);
        next('500');
      });
  }
};


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      alias: '/showreel',
      name: 'showreel',
      component: Showreel,
    },
    {
      path: '/archive',
      name: 'archive',
      component: Archive,
      beforeEnter: (to, from, next) => {
        store.state.publicSlugs.includes('archive') ? next() : next('404');
      },
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      name: 'private',
      path: '/private/:group',
      component: Private,
      props: true,
      beforeEnter: (to, from, next) => {
        store.state.privateSlug ? next() : next('404');
      },
    },
    {
      name: 'private-video',
      path: '/private/:group/:project',
      components: {
        modal: Video
      },
      props: true,
    },
    {
      name: 'video',
      path: '/:group/:project',
      components: {
        modal: Video
      },
      props: true,
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
    },
    {
      path: '/500',
      name: '500',
      component: InternalServerError,
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, _from, next) => {
  loadData(to, next);
});

export default router;
